import type { CustomDataMap, DataPointEventType, TraceErrorObject } from 'owa-analytics-types';

import { Md5 } from 'ts-md5/dist/md5';
import { isOneOf, isExternalError } from 'owa-errors';

const errorsToIgnore = ['ResizeObserver loop limit exceeded', 'ResizeObserver loop completed'];

export function ignoreError(message: string): boolean {
    return isOneOf(errorsToIgnore, message);
}

export interface CustomDataWithTable {
    customData: CustomDataMap;
    table: 'client_error' | 'client_event_dev_only' | 'client_error_external';
}

export function addFinalErrorFieldsToCustomData(
    message: string,
    errorDetails: TraceErrorObject | undefined,
    customData: CustomDataMap,
    logInDevMode?: boolean
): CustomDataWithTable {
    if (errorDetails?.response) {
        customData.status = errorDetails.response.status;
    }
    if (errorDetails?.fetchErrorType) {
        customData.fet = errorDetails.fetchErrorType;
    }

    const table: DataPointEventType = logInDevMode
        ? 'client_event_dev_only'
        : isExternalError(message, errorDetails)
          ? 'client_error_external'
          : 'client_error';

    return {
        customData,
        table,
    };
}

export function getErrorHash(message: string, errorDetails: TraceErrorObject | undefined): string {
    const hashValue = errorDetails?.stack || message;
    return (hashValue ? Md5.hashStr(hashValue) : -1)?.toString?.();
}
